import { render, staticRenderFns } from "./UsersGeneral.vue?vue&type=template&id=7b0ed55a"
import script from "./UsersGeneral.vue?vue&type=script&lang=js"
export * from "./UsersGeneral.vue?vue&type=script&lang=js"
import style0 from "./UsersGeneral.vue?vue&type=style&index=0&id=7b0ed55a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports